"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentStoreAccessControl__factory = void 0;

var _ethers = require("ethers");

/* Autogenerated file. Do not edit manually. */

/* tslint:disable */

/* eslint-disable */
class DocumentStoreAccessControl__factory extends _ethers.ContractFactory {
  constructor(signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.DocumentStoreAccessControl__factory = DocumentStoreAccessControl__factory;
const _abi = [{
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "previousAdminRole",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "newAdminRole",
    type: "bytes32"
  }],
  name: "RoleAdminChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleRevoked",
  type: "event"
}, {
  inputs: [],
  name: "DEFAULT_ADMIN_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "ISSUER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "REVOKER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }],
  name: "getRoleAdmin",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "grantRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "hasRole",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "renounceRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "revokeRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}];
const _bytecode = "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";